import {GRADING_SCALE} from '@/utils/constants';
import { isNumeric } from '@/utils/math';
import { appConfigService } from '@/providers/services/app/app-config';
import { QUESTION_CONFIG } from './question';
import moment from 'moment';
import { sessionService } from '@/providers/services/auth/session';
/**
 * Find the route path last occurrence
 * @return {String}
 */
export function getRoutePathLastOccurrence() {
  const currentLocationPath = window.location.pathname;
  return currentLocationPath.substr(currentLocationPath.lastIndexOf('/') + 1);
}

/**
 * Find the route path first occurrence
 * @return {String}
 */
export function getRoutePathFirstOccurrence() {
  const currentLocationPath = window.location.pathname;
  return currentLocationPath.split('/')[2];
}

/**
 * This Method is responsible for sorting the array object by asc or desc.
 * @param  {Array}
 * @param  {PropertyName}
 * @param  {string} 'ASC|DESC'
 */
export function sortByProperty<T>(array: T[], propName: keyof T, order: 'ASC' | 'DESC'): void {
    array.sort((a, b) => {
          if (a[propName] === null) {
            return 1;
        }
          if (b[propName] === null) {
            return -1;
        }
          if (a[propName] < b[propName]) {
            return -1;
        }

          if (a[propName] > b[propName]) {
            return 1;
        }
          return 0;
    });

    if (order === 'DESC') {
        array.reverse();
    }
}

export function gutCourseNames(courses: any) {
  courses = courses ? courses : [];
  return courses.slice(Math.floor(courses.length / 2), courses.length);
}

/**
 * Truncate given string into 72 chars
 * @function
 * @param text
 * @returns {string}
 */
export function truncateString(text: any, length = 95) {
  if (text && text.length > 100) {
    return `${text.substring(0, length)}...`;
  }
  return text;
}

export function findAnyCompetencyTitle(standards: any) {
  standards = standards ? standards : [];
  const activeStandard = standards.find((standard: any) => standard.title);
  if (activeStandard) {
    return activeStandard.title;
  }
  return null;
}

/**
 * This Method is identifying color code based on the performance
 * @param  {Number}
 */
export function getGradeRange(score: number): string {
  let scaleSize = GRADING_SCALE.length - 1;
  let range = 'not-started'; // Default color

  if (isNumeric(score)) {
    for (; scaleSize >= 0; scaleSize--) {
      if (score >= GRADING_SCALE[scaleSize].LOWER_LIMIT) {
        range = GRADING_SCALE[scaleSize].RANGE;
        break;
      }
    }
  }
  return range;
}

export function getSum(dataList: any, property: any) {
     return dataList.reduce(
        (count: any, data: any) => count + data[property], 0);
}

export function getDomainId(id: any) {
  const ids = id.split('-');
  return `${ids[0]}-${ids[1]}-${ids[2]}`;
}
export function getCourseId(id: any) {
  const ids = id.split('-');
  return `${ids[0]}-${ids[1]}`;
}

export function getSubjectId(id: any) {
  return id.substring(0, id.indexOf('-'));
}

export function isMicroStandardId(id: any) {
    return /.*\d{2}-\d{2}/.test(id) || /.*\.\d{2}\.\d{2}\./.test(id);
  }

export function getTaxonomyTags(
    taxonomy = [],
    editable = false,
    removable = false,
    canAdd = false,
  ) {
    return taxonomy.map((tagData) => {
      return  {
        isActive: false,
        isReadonly: !editable,
        isRemovable: removable,
        canAdd,
        data: tagData,
      };
    });
  }
export function unique(arr: any, prop: any) {
      const values = [...new Set(arr.map((obj: any) => obj[prop]))];
      return values.filter((item) => item);
}

export function arrUnique(arr: any) {
  let results: any = [];
  arr.map((item: any) => {
     if (item.teams) {
      results = [...new Set([...results, ...item.teams])];
     }
  });
  return results;
}

/**
 * @function getNetworkDefaultURL
 * @param {param}
 * @param {query}
 */
export function getNetworkDefaultURL(params: any, query: any, isRoot: boolean = false) {
  return {path: `${isRoot ? '/' : ''}network/${params.groupType}/${params.name}`, query};
}

/**
 * @function roundTwoDigits
 * @param num
 */
export function roundTwoDigits(num: number) {
  return Math.round((num + Number.EPSILON) * 100) / 100;
}


/**
 * Returns the question type based on apiType
 * @param {string} apiType, a valid question apiType from API 3.0
 */
export function getQuestionTypeByApiType(apiType: string) {
  let type = null;
  for (const property in QUESTION_CONFIG) {
    if (QUESTION_CONFIG.hasOwnProperty(property)) {
      if (QUESTION_CONFIG[property].apiType === apiType) {
        type = property;
        break;
      }
    }
  }
  return type;
}

/**
 * Returns a date in local time
 * @param {number} timestamp
 */
export function toLocal(timestamp: any) {
  return moment.utc(timestamp).toDate();
}

/**
 * Returns random color
 * @param {number} timestamp
 */
export function generateColor() {
  return 'rgb(2' + Math.floor(Math.random() * 100) + ',1'
            + Math.floor(Math.random() * 100) + ',0' + Math.floor(Math.random() * 100) + ')';
}

/**
 * Validating URL has protocol
 * @param url
 */
export function validateUrl(url: string = '') {
  if (url && !url.match(/^[a-zA-Z]+:\/\//)) {
    return  'http://' + url;
  }
  return url;
}

export function isEmptyValue(value: any) {
  if (value === '' || value === undefined || value === 0 || value === null
    || (typeof value === 'number' && isNaN(value))) {
    return true;
  } else {
    return false;
  }
}

export function checkCDNUrl(url: string = '') {
  const cdnUrls = sessionService.getCdnUrl();
  const contentCdnURL = cdnUrls.content_cdn_url;
  if (url) {
    if (url.indexOf('//cdn.') >= 0 ||  url.indexOf('//nile-') >= 0) {
      return url;
    } else {
      return contentCdnURL + url;
    }
  } else {
    return url;
  }

}

export function scoreValidation(event: any, maxScore: number) {
  const value = event.target.value;
  const keyValue = event.key;
  const updatedValue = value + keyValue;
  if (parseFloat(updatedValue) <= maxScore) {
     return;
  } else {
      event.preventDefault();
      event.stopPropagation();
  }
}

export function copy(items: any) {
  return JSON.parse(JSON.stringify(items));
}

/**
 * Get the resource format to be App compliant
 * @function
 * @param format
 * @returns {string}
 */
export function getResourceFormat(format: any) {
  return format ? format.split('_')[0] : undefined; // i.e video_resource to video
}

export function isAPICatchError(data: any) {
  return data.message === 'error' ? true : false;
}
